// extracted by mini-css-extract-plugin
export default {"section":"AboutUs_section__nwSHX","grid":"AboutUs_grid__sjDdM","media":"AboutUs_media__ilIKJ","copy":"AboutUs_copy__K0B1f"};